import PropTypes from "prop-types";
import React, { Fragment } from "react";
import MetaTags from "react-meta-tags";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import SectionTitleWithText from "../../components/section-title/SectionTitleWithText";
import BannerOne from "../../wrappers/banner/BannerOne";
import TextGridOne from "../../wrappers/text-grid/TextGridOne";
import FunFactOne from "../../wrappers/fun-fact/FunFactOne";
import TeamMemberOne from "../../wrappers/team-member/TeamMemberOne";
import BrandLogoSliderOne from "../../wrappers/brand-logo/BrandLogoSliderOne";
import FeatureIcon from "../../wrappers/feature-icon/FeatureIcon";

const CondizioniVendita = ({ location }) => {
  const { pathname } = location;
  var strings = require("../../translations/italian.json");
  var informazioni = global.informazioni;

  return (
    <Fragment>
      <MetaTags>
        <title>Condizioni di vendita | {informazioni.titleSite}</title>
        <meta
          name="description"
          content={"Condizioni di vendita" + " " + strings.siteContent}
        />
      </MetaTags>

      <LayoutOne>
        <Breadcrumb />

        <div
          align="justify"
          style={{ paddingLeft: "20%", paddingRight: "20%" }}
        >
          <center>
            <h2>
              Condizioni Generali di Vendita
              <br />
              <u>D.G.A. PLANET SHIRT S.R.L.</u>
            </h2>
          </center>
          <p>&nbsp;</p>
          <p>
            1) <strong>Prezzi</strong>: Tutti i prezzi sono considerati in euro,
            per singolo pezzo IVA esclusa. I Prezzi variano in base alle
            quantità. Il listino di riferimento si individua facendo il totale
            articolo per ogni colore (anche in taglie assortite.)
          </p>
          <p>
            2) <strong>Pagamenti</strong>: in contrassegno, verranno pagati alla
            consegna della merce. Le eventuali dilazioni dovranno essere sempre
            concordate con la direzione. Addebiteremo per spese amministrative €
            20,00 in caso di insoluto assegno bancario, € 10,00 in caso di
            insoluti per Ricevute Bancarie, oltre agli interessi di legge e
            verranno automaticamente revocate le condizioni preferenziali
            concesse.
          </p>
          <p>
            3) <strong>Trasporto</strong>: È a carico dell’acquirente. La merce
            è consegnata in porto assegnato o con nostro corriere convenzionato
            con l’addebito in fattura del costo previsto dall’accordo con il
            trasportatore.{" "}
          </p>
          <p>
            <u>
              <strong>
                Per ordini con imponibile minimo di € 400.00 spedizione in porto
                franco.
              </strong>
            </u>
          </p>
          <p>
            <strong>Tariffa Italia</strong>: 1° collo € 12,90 + 2 ° collo € 6,00
            + € 4,00 i successivi + € 2.00 spese contrassegno
          </p>
          <p>
            In riferimento alle spedizioni, si informa la clientela che per la
            gestione dell’ordine sarà addebitato € 1,00 in fattura.{" "}
          </p>
          <p>
            4) <strong>Ordini</strong>: Gli ordini pervenuti saranno evasi in
            base alla tipologia di evasione richiesta dal cliente:{" "}
          </p>
          <p>
            <strong>Tutto in un’unica soluzione</strong>: l’ordine sarà evaso
            soltanto quando tutti gli articoli in riferimento allo stesso
            saranno disponibili, pagando un unico costo di spedizione.
          </p>
          <p>
            <strong>Il disponibile e il restante all’arrivo</strong>: : la merce
            disponibile sarà evasa quanto prima e il restante all’arrivo. La
            merce messa su prenotazione e quindi divenuta disponibile sarà
            spedita senza alcun preavviso, con l’addebito di ulteriori costi di
            spedizione, e{" "}
            <strong>
              non potrà essere unita ad altri ordini, viaggerà separatamente
            </strong>
            .
          </p>
          <p>
            5) <strong>Consegne</strong>: non ci riterremo responsabili di
            eventuali furti o smarrimenti della merce durante il trasporto. Le
            eventuali spese derivanti da ritardi o mancati ritiri saranno a
            carico del cliente.
          </p>
          <p>
            6) <strong>Reclami</strong>: dovranno essere comunicati per e-mail
            entro un massimo di 8 gg dal ricevimento della merce. In caso di
            colli mancanti o danneggiati alla consegna, scriverlo sul DDT o
            lettera di vettura del trasportatore, firmando con riserva.
          </p>
          <p>
            7) <strong>Resi</strong>: Trascorsi gli 8 gg lavorativi dalla
            consegna della merce, non sarà più possibile renderla, in quanto
            trascorso questo tempo, siamo impossibilitati nel controllo e
            verifica dell’errore. Inoltre, saranno respinti i resi non
            autorizzati dalla nostra società, e non verranno accettati in nessun
            modo resi di capi personalizzati, si prega quindi di riscontrare la
            merce prima di procedere alla personalizzazione. Per resi non
            derivati da errori imputabili alla nostra società, se accettati,
            verrà fatturato il 10% dell’importo della merce resa con un minimo
            di € 10,00 e tutte le spese sostenute per il trasporto.{" "}
          </p>
          <p>
            8) <strong>Grammature</strong>: la tolleranza indicata è di circa il
            5%, poiché sono prodotti in continuo sviluppo saranno possibili
            variazioni tecniche.
          </p>
          <p>
            9) <strong>Taglie</strong>: la tolleranza per la misura delle taglie
            è di circa 2.5 cm. Rispetto alle misure standard di ogni fornitore,
            poiché i prodotti sono in continuo sviluppo saranno possibili
            variazioni di taglia.
          </p>
          <p>
            10) <strong>Colori</strong>: Per ragioni tecniche, lotti diversi di
            produzione possono comportare differenze nella tonalità dei colori,
            senza però modificare la qualità del prodotto.
          </p>
          <p>
            I colori riprodotti sul catalogo e su sito D.G.A. sono orientativi.
          </p>
          <p>
            11) <strong>Disponibilità merce</strong>: in caso di mancanza merce
            sarà nostra premura informare sulle future date di consegna, non ci
            riteniamo responsabili per posticipi da parte dell’azienda a noi
            fornitrice.
          </p>
          <p>
            Per alcuni articoli presenti a catalogo di cui non faremo magazzino,
            sarà comunque possibile acquistarli, ad un costo maggiore.
          </p>
          <p>
            12) <strong>Ritiri in sede</strong>: si informa la clientela che per
            la gestione dell’ordine sarà addebitato € 2,00 in fattura.
          </p>
          <p>
            Trascorsi 7 gg dalla data di prenotazione, in mancanza di ritiro
            sarà addebitato un supplemento di € 10.00 per gestione magazzino.
            Trascorsi 15 gg l’ordine si riterrà annullato, con ulteriore
            addebito di € 10,00 per gestione magazzino.
          </p>
          <p>
            13) <strong>Foro competente</strong>: per qualsiasi controversia è
            esclusivamente competente il foro di Torre Annunziata.
          </p>
        </div>

        <BrandLogoSliderOne spaceBottomClass="pb-70" />
      </LayoutOne>
    </Fragment>
  );
};

CondizioniVendita.propTypes = {
  location: PropTypes.object,
};

export default CondizioniVendita;
